<template>
  <el-row class="warning-block">
    <el-row>
      <el-col :span="1"><el-row class="zy-icon-warning" /></el-col>
      <el-col :span="4">
        <el-row class="screen-title">告警</el-row>
        <el-row class="title-underline"/>
      </el-col>
    </el-row>

    <el-row style="align-items: center;" :style="getDiffStyle(0)">
      <el-col class="left-border-title screen-title">当月告警趋势</el-col>
    </el-row>

    <el-row class="warning-chart-box" :style="getDiffStyle(0)">
      <common-charts :index="'_screen_warning'" :key="timeStamp"
                    :style="getDiffStyle(3)"
                    :options="warningTend"/>
    </el-row>

    <el-row style="align-items: center;" :style="getDiffStyle(0)">
      <el-col class="left-border-title screen-title">最近告警</el-col>
    </el-row>

    <seamless-scroll :data="alarmList" class="warning-list-box" :key="this.alarmList.length" :class-option="classOption" :style="getDiffStyle(0)">
      <el-row class="warning-list-row" v-for="(info, i) in alarmList" :key="i">
        <el-col :span="13">{{ info.ercName }}</el-col>
        <el-col :span="7" style="text-align: right;">{{ info.data_time }}</el-col>
        <el-col :span="3" style="text-align: right;">{{ (info.ercLevel === '2' ? '未处理':'已处理') }}</el-col>
      </el-row>
    </seamless-scroll>
  </el-row>
</template>

<script>
import buildCoalLineConfig from "../../../config/chart/config_coal_line";
import CommonCharts from "../../common/chart/CommonCharts";
import seamlessScroll from "vue-seamless-scroll"

export default {
  name: "WarningBlock",
  components: {CommonCharts, seamlessScroll},
  props: ["isFull", "alarmMap", "alarmList"],
  data() {
    return {
      infos: [],
      warningTend: {},
      timeStamp: 0
    }
  },
  watch: {
    alarmMap: function (newV, oldV) {
      if(oldV !== newV) this.setChart();
    }
  },
  created() {
    this.$nextTick(function () {
      this.setChart()
    })
    // this.$api.energyMonitor.getRecentAlarm(20).then(res => {
    //   res.data.forEach(notice => {
    //     let texts = notice.split(' ');
    //     texts[2] = texts[2].replace('年', '.');
    //     texts[2] = texts[2].replace('月', '.');
    //     texts[2] = texts[2].replace('日', ' ');
    //     this.infos.push({label: texts[0], state: texts[1], timeStr: texts[2]})
    //   })
    // })
  },
  computed: {
    classOption () {
      return {
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: this.infos.length, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        openTouch: false,
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  methods: {
    getDiffStyle(type) {
      if (type === 0) return this.isFull ? 'margin-top: 18px;' : 'margin-top: 12px;'
      if (type === 1) return this.isFull ? 'margin-top: 8px;' : 'margin-top: 3px;'
      if (type === 2) return this.isFull ? 'margin-top: 24px;' : 'margin-top: 16px;'
      if (type === 3) return this.isFull ? 'height: 156px;' : 'height: 116px;'
    },
    setChart() {
      let tendLegend = this.alarmMap.dataDate;
      let tendData = this.alarmMap.dataData ? this.alarmMap.dataData.split(',') : '0, 0, 0';
      this.warningTend = buildCoalLineConfig(tendLegend, tendData);

      this.timeStamp = new Date().getTime()
    }
  }
}
</script>

<style scoped>
.warning-block{
  margin: 9px 0 0 16px;
  padding: 10px 0 0 20px;
  width: 582px;
  height: 500px;
  color: #15AEFE;
  background: url("../../../assets/images/digital-screen/digital-bg.png");
  background-size: 100% 100%;
}
.warning-chart-box{
  height: 32%;
}
.warning-list-box{
  height: 38%;
  overflow: hidden;
  flex-wrap: nowrap;
}
.warning-list-row {
  color: #98CBCA;
  height: 24px;
  align-items: center;
  text-align: left;
  font-size: 14px;
}
.zy-icon-warning {
  width: 25px;
  height: 26px;
  background: url("../../../assets/images/digital-screen/icon-warning.png");
}
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/DigitalScreen/WarningBlock.vue